import { SELECIONAR_TRECHO_PASSAGEIRO } from '../types'

export default function selecionarTrechoPassageiro (trecho) {
  return {
    type: SELECIONAR_TRECHO_PASSAGEIRO,
    payload: trecho
  }
}